import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import './App.css';

const PAGE_SIZE = 25;

function App() {
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [data, setData] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://hts.dg0011.com/api.php?page=${currentPage}&pageSize=${PAGE_SIZE}&searchSender=${encodeURIComponent(searchInput)}`);
        console.log('API Response:', response.data);

        if (Array.isArray(response.data.records)) {
          const total = parseInt(response.data.totalRecords, 10);
          setTotalRecords(total);
          setTotalPages(Math.ceil(total / PAGE_SIZE));
          setData(response.data.records);
        } else {
          console.error('API Response does not contain an array of records:', response.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentPage, searchInput]);

  const handlePageChange = newPage => {
    setCurrentPage(newPage);
  };

  const handleSearchChange = event => {
    setSearchInput(event.target.value);
    setCurrentPage(0); // Reset page when searching
  };

  const Row = ({ record }) => (
    <div className="ListItem">
      <div className="Rank">{record.rank}</div>
      <div className="Sender">{record.sender}</div>
      <div className="Amount">{record.amount}</div>
    </div>
  );

  return (
    <div className="container">
      <Helmet>
        <title>HTS</title>
      </Helmet>
      <div className="LogoContainer">
        <img src="logo.png" alt="HTS2 Logo" className="Logo" />
        <input
          type="text"
          placeholder="Search..."
          className="SearchInput"
          value={searchInput}
          onChange={handleSearchChange}
        />
      </div>
      <h3>Total: 21000000</h3>
      <h3>Holders: {loading ? 'Loading...' : totalRecords}</h3>
      <h4>Telegram: <a href="https://t.me/hts_heco">https://t.me/hts_heco</a></h4>
      <div className="ListContainer">
        <div className="ListHeader">
          <div className="Rank">Rank</div>
          <div className="Sender">Address</div>
          <div className="Amount">Amount</div>
        </div>
        <div className="List">
          {data.map((record, index) => (
            <Row key={index} record={record} />
          ))}
        </div>
      </div>

      <div className="pagination">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 0}
        >
          《《
        </button>
        <span>
          Page {currentPage + 1} of {totalPages}
        </span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={(currentPage + 1) * PAGE_SIZE >= totalRecords}
        >
          》》
        </button>
      </div>
    </div>
  );
}

export default App;
